import { connect } from 'react-redux';
import About from 'components/About';
import { getSection } from 'website/website.selectors';

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  const sectionData = getSection(state, "INFO")[0].data;
  const listings = state.listings.results;
  return {
    title: sectionData.title,
    description: sectionData.description,
    listings: listings,
    listingsCount: state.listings.count,
    markers: listings && Object.keys(listings).map(l => ({ listing: listings[l], position: { lng: listings[l].address.lng, lat: listings[l].address.lat }}))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(About);


// WEBPACK FOOTER //
// ./src/containers/About.container.js